module.exports = __webpack_public_path__ + "media/images/countryrect/sr-bd65cfdff30a36865c421db76ea0c813.svg";